import { Dialog, Flex, Heading, Text } from '@applyboard/crystal-ui'
import { Dispatch, SetStateAction } from 'react'
import { SpecificFieldValidationErrorField } from '../../../utils/specificFieldValidations'

type SpecificFieldsValidationErrorsDialogProps = {
  open: boolean
  onOpenChange: Dispatch<SetStateAction<boolean>>
  errors: SpecificFieldValidationErrorField[]
}

export function SpecificFieldsValidationErrorsDialog(
  props: Readonly<SpecificFieldsValidationErrorsDialogProps>,
) {
  const { open, onOpenChange, errors } = props

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Heading>Action Required Before Submission</Dialog.Heading>
      <Dialog.Content>
        <Flex direction="column" gap={4}>
          <Heading level={3} variant="titleL">
            Missing Required Fields
          </Heading>
          <Text>
            You can't submit your application yet. Please ensure all mandatory fields are completed
            before attempting to submit your application again:
          </Text>
          <ul>
            {errors.map(error => (
              <li key={`${error.field}-${error.label}`}>
                <Text>{error.label}</Text>
              </li>
            ))}
          </ul>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Return to application</Dialog.CloseButton>
      </Dialog.Actions>
    </Dialog>
  )
}
